import medicalequ from "../../Assets/medical-equ.png"
import empowered1 from "../../Assets/empowering1.png"
import empowered2 from "../../Assets/empowering2.png"
import empowered3 from "../../Assets/empowering3.png"
import empowered4 from "../../Assets/empowering4.png"
import empowered5 from "../../Assets/empowering5.png"
import empowered6 from "../../Assets/empowering6.png"
import empowered7 from "../../Assets/empowering7.png"
import empowered8 from "../../Assets/empowering8.png"
import empowered9 from "../../Assets/empowering9.png"
import empowered10 from "../../Assets/empowering10.png"
import empowered11 from "../../Assets/empowering11.png"
import settle1 from "../../Assets/settle1.png"
import settle2 from "../../Assets/settle2.png"
import settle3 from "../../Assets/settle3.png"
import settle4 from "../../Assets/settle4.png"
import chooseexcellence from "../../Assets/chooseexcellence.png"
import rupesh from "../../Assets/rupesh.png"
import baskar from "../../Assets/baskar.png"
import naveen from "../../Assets/naveen.png"

export const serviceShowcaseData = [
    {
        imgSrc: medicalequ,
        title: `From Our Door To Yours \n We Deliver More Than \n Medical Equipment`,
        buttonText: "Book Now",
        onButtonClick: () => console.log("Button Clicked"),
    }
]

export const medical_text = {
    heading: `No Hassle, Just Care`,
    para: `Say goodbye to long waits and cumbersome trips to the store. With our convenient at-home medical equipment service,\n you can get everything you need without leaving the comfort of your home. Whether it's for recovery, daily assistance,\n or improving your wellness routine, our hassle-free delivery ensures you have the tools you need to thrive.`
}

export const cardsh2 = `Empowering You With Options`;
export const cardsh4 = `Buy Or Rent Medical Equipment From Us`

export const medicalequ_data = {
    o1: { title: "Oxygen Concentrator", img: empowered1 },
    o2: { title: "Cardiac Monitors", img: empowered2 },
    o3: { title: "Wheel Chairs", img: empowered3 },
    o4: { title: "Motorized Bed", img: empowered4 },
    o5: { title: "Suction Apparatus", img: empowered5 },
    o6: { title: "Pulse Oximeter", img: empowered6 },
    o7: { title: "3M, N95 Masks", img: empowered7 },
    o8: { title: "Nebulizer", img: empowered8 },
    o9: { title: "BP Apparatus", img: empowered9 },
    o10: { title: "Infusion Pump", img: empowered10 },
    o11: { title: "Posture Corrector", img: empowered11 },
};

export const settle_title = `Why Settle For Anything Less?`;

export const why_settle_data = {
    o1: { title: "  Warranty Covered", img: settle1 },
    o2: { title: "  Free Installation", img: settle2 },
    o3: { title: "  ChaDiverse Rangeirs", img: settle3 },
    o4: { title: "  Flexibility Meets Affordability", img: settle4 },
}

export const chooseexcellence_data = {
    title: `Choose Excellence`,
    subheading: `Don’t Blend In`,
    para: `Transform your home into a wellness sanctuary with the trendiest medical equipment, because health and style go hand in hand. Ordering medical equipment from us means choosing excellence in both products and services. With our extensive selection and knowledgeable staff, we're here to support you every step of the way.`,
    image: chooseexcellence
}
export const medicalequ_equ_testimonials = [
    {
        title: `We’ll Let Our Clients Do The Talking`,
        desc: `Renting from Wihan Home Health Services was the perfect solution for
my short-term medical needs. The equipment was delivered promptly,
and the rental terms were flexible. I appreciated the convenience and
affordability of their rental service.`,
        userimg: rupesh,
        username: "Rupesh Kumar"
    },
    {
        title: `We’ll Let Our Clients Do The Talking`,
        desc: `Whether you're buying or renting, Wihan Home Health Services is the way
to go for medical equipment. I initially rented a wheelchair for my
grandmother, and when we decided to purchase other equipment,
Wihan was our first choice. Their products are reliable, & their service
is exceptional.`,
        userimg: baskar,
        username: "Baskar Kethavath"
    },
    {
        title: `We’ll Let Our Clients Do The Talking`,
        desc: `After my father’s surgery, we needed a hospital bed urgently. Wihan Home Health Services delivered and set it up the same day. The equipment was clean, sturdy, and in perfect condition. Their quick response and professionalism really stood out.`,

        userimg: naveen,
        username: "Naveen Reddy"
    },
]